import { userService } from '../../helpers/easyindustriaapi/user.service';
import router from '../../router/index';

function readStorage(key) {
    try { return JSON.parse(localStorage.getItem(key)); } catch (e) { return null; }
}

//initial state
export const state = { status: {}, user: readStorage('user'), currentEmpresa: readStorage('currentEmpresa') };

export const mutations = {
    loginSuccess(state, user) {
        state.status = { loggeduser: true };
        state.user = user;
		state.currentEmpresa = null;
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
		state.currentEmpresa = null;
    },
    logout(state) {
        state.status = {};
        state.user = null;
		state.currentEmpresa = null;
    },
    registerRequest(state) {
        state.status = { registering: true };
    },
    registerSuccess(state) {
        state.status = {};
    },
    registerFailure(state) {
        state.status = {};
    },
    resetpassWordRequest(state) {
        state.status = { resetpassword: true };
    },
    resetpassWordSuccess(state) {
        state.status = {};
    },
    resetpassWordFailure(state) {
        state.status = {};
    },
    listUsersRequest(state) {
        state.users = null;
        state.status = { listed: true };
    },
    listUsersSuccess(state, users) {
        state.status = {};
        state.users = users;
    },
    listUsersFailure(state) {
        state.status = {};
        state.users = null;
    },
    selectedEmpresaRequest(state, payload) {
        state.status = { loggingIn: true };
		if (payload && payload.Empresa) {
			state.currentEmpresa = payload.Empresa;
		} else {
			state.currentEmpresa = currentEmpresa;
		}
    },
    selectedEmpresa(state, currentEmpresa) {
		state.status = {};
        state.status = { loggeduser: true };
		state.currentEmpresa = currentEmpresa;
    },
};

export const getters = {
    // Whether the user is currently logged in.
    loggedIn(state) {
        return !!state.user
    },
    hasPermission: (state) => (permission) => {
        if (!state.user || !Array.isArray(state.user.permissions)) return false;
        if (state.user.roles && state.user.roles.some(role => role.name === 'super')) return true;
        return state.user.permissions.some(item => item && item.name === permission);
    },
};

export const actions = {
    // Logs in the user.
    // eslint-disable-next-line no-unused-vars
    loGin({ dispatch, commit }, { email, password }) {
        userService.login(email, password)
            .then(
                user => {
                    commit('loginSuccess', user);
                    router.push('/select-company');
                },
                error => {
                    if (error === 'Unauthorized') {
                        error = 'Login ou senha inválidos';
                    }
                    
                    commit('loginFailure', error);
                    dispatch('notification/error', error, { root: true });
                }
            );
    },

    // Logout the user
    loGout({ commit }) {
        userService.logout();
        commit('logout');
    },
	resetpassWord({ dispatch, commit }, email) {
		commit('resetpassWordRequest', email);
		
		return userService.resetpassword(email)
			.then(
				response => {
					commit('resetpassWordSuccess', response);
					dispatch('notification/success', 'Link para redefinição de senha enviado para o e-mail', { root: true });
					return response;
				},
				error => {
					commit('resetpassWordFailure', error);
					dispatch('notification/error', error, { root: true });
					return Promise.reject(error);
				}
			);
	},
    // register the user
    registerUser({ dispatch, commit }, user) {
        commit('registerRequest', user);
        userService.register(user)
            .then(
                user => {
                    commit('registerSuccess', user);
                    dispatch('notification/success', 'Cadastro realizado com sucesso', { root: true });
                    router.push({ name: 'userGetAll' });
                },
                error => {
                    commit('registerFailure', error);
                    dispatch('notification/error', error, { root: true });
                }
            );
    },
    getAll({ dispatch, commit }, Aid) {
        userService.getAll(Aid)
            .then(
                users => {
                    commit('listUsersSuccess', users);
                    // dispatch('notification/success', 'Lista carregada', { root: true });
                    // router.push('/userGetAll');
                },
                error => {
                    commit('listUsersFailure', error);
                    dispatch('notification/error', error, { root: true });
                }
            )
    },
    selectEmpresa({ commit }, Empresa) {
		commit('selectedEmpresaRequest', { Empresa });
		localStorage.setItem('currentEmpresa', JSON.stringify(Empresa));
		commit('selectedEmpresa', Empresa);
    },
};
